import AppSidebar from "./AppSidebar";
import { Separator } from "@/components/ui/separator";
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "@/components/ui/sidebar";
import { Outlet, useLocation } from "react-router";
import { titles } from "./dashboardLayout.constants";
import { Suspense } from "react";

export default function DashboardLayout() {
  const location = useLocation();
  const title = titles[location.pathname as keyof typeof titles];

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <header className="flex h-16 shrink-0 items-center gap-2 border-b px-4">
          <SidebarTrigger className="-ml-1" />
          <Separator orientation="vertical" className="mr-2 h-4" />
          <h4>{title || ""}</h4>
        </header>
        <Suspense fallback={<div>Loading...</div>}>
          <div className="p-6 h-full">
            <Outlet />
          </div>
        </Suspense>
      </SidebarInset>
    </SidebarProvider>
  );
}
